import type { Audience } from "~/shared/theme/audience"

export interface AudienceInput {
  readonly title?: string | null
  readonly ministryArea?: string | null
}

/**
 * Order is load-bearing twice over. Students precedes men so the teen edition of
 * a men's study classifies as students, which is who it is for. Women precedes
 * men as a second guard behind the word boundaries.
 */
const PATTERNS: readonly (readonly [Audience, RegExp])[] = [
  ["students", /\b(?:teen|teens|student|students|youth)\b/i],
  ["kids", /\b(?:vbs|kid|kids|children)\b/i],
  ["women", /\b(?:women|woman|womens)\b/i],
  ["men", /\b(?:men|man|mens|manhood)\b/i],
]

const DEFAULT_AUDIENCE: Audience = "adults"

/**
 * `ministryArea` is asked first because it is a curator's answer to this exact
 * question, where a title only implies one. Neither is reliable, which is why
 * everything unmatched lands on adults rather than on an "unknown" the UI would
 * have to render.
 */
export const classify = ({ title, ministryArea }: AudienceInput): Audience => {
  for (const source of [ministryArea, title]) {
    if (!source) {
      continue
    }

    const match = PATTERNS.find(([, pattern]) => pattern.test(source))

    if (match) {
      return match[0]
    }
  }

  return DEFAULT_AUDIENCE
}
